<template>
  <div class="legislative-table">
    <div>
      <v-client-table
        id="legislative"
        ref="legislative"
        name="legislative"
        :data="legislativeTable"
        :columns="columns"
        :options="options"
      >
        <div slot="afterFilter">
          <span><i class="fas fa-search fa-2x" /></span>
        </div>
        <div
          slot="bill_number"
          slot-scope="{row}"
          style="display: flex; flex-direction: column; align-items: top;"
        >
          <!-- Bill Number -->
          <div v-if="row.bill_number">
            <div v-if="row.bill_link">
              <a :href="row.bill_link">{{ row.bill_number }}</a>
            </div>
            <div v-else>
              {{ row.bill_number }}
            </div>
          </div>
          <!-- Resolution Number -->
          <div v-if="row.resolution_number">
            <div v-if="row.resolution_link">
              <a :href="row.resolution_link">{{ row.resolution_number }}</a>
            </div>
            <div v-else>
              {{ row.resolution_number }}
            </div>
          </div>
          <div v-if="row.resolution_number_2">
            <div v-if="row.resolution_link_2">
              <a :href="row.resolution_link_2">{{ row.resolution_number_2 }}</a>
            </div>
            <div v-else>
              {{ row.resolution_number_2 }}
            </div>
          </div>
          <div v-if="row.resolution_number_3">
            <div v-if="row.resolution_link_3">
              <a :href="row.resolution_link_3">{{ row.resolution_number_3 }}</a>
            </div>
            <div v-else>
              {{ row.resolution_number_3 }}
            </div>
          </div>
          <div v-if="row.resolution_number_4">
            <div v-if="row.resolution_link_4">
              <a :href="row.resolution_link_4">{{ row.resolution_number_4 }}</a>
            </div>
            <div v-else>
              {{ row.resolution_number_4 }}
            </div>
          </div>
        </div>
        <div
          slot="bill_title"
          slot-scope="{row}"
          style="display: flex; flex-direction: column; align-items: top;"
        >
          <!-- Bill Title -->
          <div v-if="row.bill_title">
            {{ truncateText(row.bill_title) }}
          </div>

          <div v-if="row.bill_title && row.resolution_title">
            <!-- Resolution Title -->
            <div
              v-if="row.resolution_title"
              class="resolution-title"
            >
              {{ truncateText(row.resolution_title) }}
            </div>
            <div
              v-if="row.resolution_title_2"
              class="resolution-title"
            >
              {{ truncateText(row.resolution_title_2) }}
            </div>
            <div
              v-if="row.resolution_title_3"
              class="resolution-title"
            >
              {{ truncateText(row.resolution_title_3) }}
            </div>
            <div
              v-if="row.resolution_title_4"
              class="resolution-title"
            >
              {{ truncateText(row.resolution_title_4) }}
            </div>
          </div>
        </div>
        <div
          slot="fiscal_note_download"
          slot-scope="{row}"
          style="display: flex; align-items: top;"
        >
          <a
            :href="legislativeUrl+row.fiscal_note_download"
          >{{ row.fiscal_note_download }}</a>
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>
window.moment = require('moment');

export default {
  name: 'LegislativeAffairsTable',
  props: {
    legislativeTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
    pageInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function() {
    return {
      legislativeUrl: process.env.VUE_APP_LEGISLATIVE_AFFAIRS_URL,
      columns: [ "bill_number", "bill_title", "prime_sponsor", "introduction_date", "committee", "fiscal_note_download" ],
      hiddenColumns: [ "bill_link", "resolution_link" ],
      filterable: true,
      options: {
        orderBy: {
          column: 'bill_number',
          ascending: false,
        },
        addSortedClassToCells: true,
        dateColumns: [ 'introduction_date' ],
        toMomentFormat: 'MM/DD/YYYY',
        dateFormat: 'MM/DD/YYYY',
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-up',
          down: 'fa-sort-down',
        },
        texts: {
          filterPlaceholder: "Search titles",
        },
        perPage: 10,
        perPageValues: [],
        pagination: {
          chunk : 3,
        },
        headings: {
          bill_number: 'Bill and resolution numbers',
          bill_title: 'Title(s)',
          prime_sponsor: 'Introduced by',
          introduction_date: 'Date introduced',
          committee: 'Assigned committee',
          fiscal_note_download: "Link to fiscal note",
          bill_link: 'Bill Link',
        },
      },
    };
  },
  methods: {
    truncateText(text) {
      if (text.length <= 200) {
        return text;
      }
      return text.substring(0, 200) + '...';
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.tooltip-icon {
  width: 42px;
  padding: 0 10px;
  color: #0f4d90;
  &:hover {
    color:#444444;
  }
}

.resolution-title {
  padding-top: 5px;
}

</style>
